/**
 * get cookie
 * 根据 key 获取对应的 cookie 的 value
 */
export function get(sKey) {
  if (!sKey) {
    return null
  }
  return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null
}

/**
 * put cookie
 * 根据 key 设置 cookie 的 value
 */
export function put(sKey, sValue, options) {
  options = options || {}
  var vEnd = options.vEnd,
    sPath = options.sPath,
    sDomain = options.sDomain,
    bSecure = options.bSecure

  if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
    return false
  }
  var sExpires = ''
  if (vEnd) {
    switch (vEnd.constructor) {
    case Number:
      sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd
      break
    case String:
      sExpires = '; expires=' + vEnd
      break
    case Date:
      sExpires = '; expires=' + vEnd.toUTCString()
      break
    }
  }
  document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '')
  return true
}

/**
 * remove cookie
 * 根据 key 移除对应的 cookie
 */
export function remove(sKey, sPath, sDomain) {
  if (!has(sKey)) {
    return false
  }
  document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '')
  return true
}

/**
 * has cookie
 * 根据 key 判断是否存在对应的 cookie
 */
export function has(sKey) {
  if (!sKey) {
    return false
  }
  return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie)
}

/**
 * get cookie keys
 * 获取当前 cookie 的全部 key
 */
export function keys() {
  var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/)
  for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx])
  }
  return aKeys
}

// 作为单一对象 export
export default {
  get: get,
  put: put,
  remove: remove,
  has: has,
  keys: keys
}
